import * as Types from '../../tenants/kwg/generated';

import { RoleAssignmentFragmentDoc } from '../roleAssigments/roleAssignments.fragment.g';

export const GroupFragmentDoc = `
    fragment Group on Group {
  id
  name
  syncGroupSecurityIdentifier
  memberships {
    totalCount
  }
  roleAssignments(first: 100) {
    nodes {
      ...RoleAssignment
    }
  }
}
    `;
export const GroupDetailFragmentDoc = `
    fragment GroupDetail on Group {
  id
  name
  roleAssignments(first: 100) {
    nodes {
      ...RoleAssignment
    }
  }
  users(first: 100) {
    nodes {
      id
      name
      loginName
      email
    }
  }
}
    `;
// @ts-ignore
// auto-added to satisfy TS unused import
void 0 && Types;
